import { Outlet } from '@tanstack/react-router';
import { TabBar, type Tab } from '@/shared/ui/TabBar';
import { CarIcon, HistoryIcon, UserIcon } from '@/shared/ui/icons';

/**
 * The three-tab shell — the app's information architecture, and the one thing the prototype,
 * both mobile clients and this agree on exactly. The «Главная» glyph is a car, not a house:
 * that is what the prototype uses, and the house was a drift introduced here in wave 1.
 */
const TABS: Tab[] = [
  { to: '/', label: 'Главная', icon: <CarIcon /> },
  { to: '/history', label: 'История', icon: <HistoryIcon /> },
  { to: '/profile', label: 'Профиль', icon: <UserIcon /> },
];

export function AppShell() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </div>
      <TabBar tabs={TABS} />
    </div>
  );
}
